import { render, staticRenderFns } from "./TicketQuickView.vue?vue&type=template&id=6bfdd25a&scoped=true&"
import script from "./TicketQuickView.vue?vue&type=script&lang=js&"
export * from "./TicketQuickView.vue?vue&type=script&lang=js&"
import style0 from "./TicketQuickView.vue?vue&type=style&index=0&id=6bfdd25a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfdd25a",
  null
  
)

export default component.exports